

















import { Vue, Component } from "vue-property-decorator";
import WidgetForm from "@/components/integrations/WidgetForm.vue";

@Component({ components: { WidgetForm } })
export default class WidgetCreate extends Vue {}
